import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = categories.filter((c) =>
    t(`categories.${c.id}`).toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div ref={ref} className="relative w-full">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-white/30 bg-white/95 px-4 py-3 text-left text-sm text-foreground-700 transition-colors hover:bg-white cursor-pointer"
      >
        <span className="flex items-center gap-2">
          <i className="ri-apps-2-line text-base w-4 h-4 flex items-center justify-center text-primary-600"></i>
          <span className="font-medium">{t("hero.dropdownLabel")}</span>
        </span>
        <i className="ri-arrow-down-s-line text-base w-4 h-4 flex items-center justify-center text-foreground-500"></i>
      </button>

      {open && (
        <div className="absolute left-0 right-0 z-30 mt-2 overflow-hidden rounded-lg border border-background-300 bg-white">
          <div className="border-b border-background-100 p-3">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={t("hero.searchPlaceholder")}
                className="w-full rounded-md border border-background-200 bg-background-50 py-2 pl-9 pr-3 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 focus:border-primary-300"
              />
            </div>
          </div>
          <ul className="max-h-72 overflow-y-auto py-1">
            {filtered.length === 0 && (
              <li className="px-4 py-3 text-sm text-foreground-500">
                {t("hero.noResults")}
              </li>
            )}
            {filtered.map((c) => (
              <li key={c.id}>
                <a
                  href={c.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-arrow-right-up-line text-sm w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                    {t(`categories.${c.id}`)}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}